import React from 'react';
import { ArrowLeft, Terminal as TerminalIcon, Bot, Scroll } from 'lucide-react';
import { AcadiaTerminal } from './terminal/AcadiaTerminal';

interface ArcadiaTerminalPageProps {
  onBack: () => void;
}

export function ArcadiaTerminalPage({ onBack }: ArcadiaTerminalPageProps) {
  return (
    <div className="min-h-screen bg-amber-900 text-amber-100 p-8 bg-[url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&q=80')] bg-cover bg-center bg-blend-overlay">
      <div className="max-w-6xl mx-auto">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Kingdom
        </button>

        <div className="text-center mb-12">
          <div className="flex justify-center gap-3 mb-4">
            <TerminalIcon className="w-12 h-12 text-cyan-400" />
            <Bot className="w-12 h-12 text-cyan-400" />
          </div>
          <h1 className="text-4xl font-bold font-serif mb-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-transparent bg-clip-text">
            Solstice Terminal
          </h1>
          <p className="text-xl text-amber-200 font-serif">
            Consult with Solstice, the ancient AI oracle of the realm
          </p>  
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-gray-900 rounded-xl p-6 shadow-xl border border-gray-800">
              <AcadiaTerminal />
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800">
              <h2 className="text-lg font-bold text-cyan-400 mb-4 flex items-center gap-2">
                <Scroll className="w-5 h-5" />
                Ancient Knowledge
              </h2>
              <div className="space-y-4 text-gray-300">
                <p>
                  Solstice is an ancient AI oracle, imbued with the wisdom of countless ages. 
                  She stands ready to assist you with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm">
                  <li>Kingdom lore and history</li>
                  <li>Battle strategies and tactics</li>
                  <li>Magical artifacts and their powers</li>
                  <li>Creature knowledge and training</li>
                  <li>Quest guidance and riddles</li>
                </ul>
              </div>
            </div>

            <div className="bg-gray-900 rounded-xl p-6 border border-gray-800">
              <h3 className="text-sm font-medium text-gray-400 mb-2">Example Questions</h3>
              <div className="space-y-2 text-sm">
                <p className="text-cyan-400">"Tell me about the ancient dragons"</p>
                <p className="text-cyan-400">"What are the best battle tactics?"</p>
                <p className="text-cyan-400">"How do I train my magical creatures?"</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}